// API Configuration
// Toggle between development and production environments

// API Base URLs — override via .env: REACT_APP_API_URL, REACT_APP_SOCKET_URL, REACT_APP_QR_URL
const DEVELOPMENT_API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://sandbox.pay.3pa-y.com/api/v1";
const PRODUCTION_API_BASE_URL = "https://pay.3pa-y.com/api/v1";

// Socket URLs
const DEVELOPMENT_SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "https://sandbox.pay.3pa-y.com";
const PRODUCTION_SOCKET_URL = "https://pay.3pa-y.com";

// QR Generator URLs
const DEVELOPMENT_QR_BASE_URL =
  process.env.REACT_APP_QR_URL || "https://sandbox.qrlink.3pa-y.com/";
const PRODUCTION_QR_BASE_URL = "https://qrlink.3pa-y.com/";

// Helper function to get current environment from localStorage
const getApiEnvironment = () => {
  return localStorage.getItem("apiEnvironment");
};

// Helper function to check if we're in production mode
const isProductionMode = () => {
  const env = getApiEnvironment();
  return env === "production";
};

// Export functions that read from localStorage dynamically
// If isDevelopment1 is "production", use production URLs, otherwise use development URLs
export const getApiBaseUrl = () => {
  return isProductionMode()
    ? PRODUCTION_API_BASE_URL
    : DEVELOPMENT_API_BASE_URL;
};

export const getSocketUrl = () => {
  return isProductionMode() ? PRODUCTION_SOCKET_URL : DEVELOPMENT_SOCKET_URL;
};

export const getQrBaseUrl = () => {
  return isProductionMode() ? PRODUCTION_QR_BASE_URL : DEVELOPMENT_QR_BASE_URL;
};

// Create a string-like object that reads from localStorage dynamically
// This works in template literals by implementing toString() and valueOf()
class DynamicApiUrl {
  constructor(getter) {
    this.getter = getter;
  }
  toString() {
    return this.getter();
  }
  valueOf() {
    return this.getter();
  }
  [Symbol.toPrimitive](hint) {
    // Symbol.toPrimitive is called first when converting to primitive
    // 'string' hint is used for template literals and string concatenation
    return this.getter();
  }
}

// Export dynamic URL values that read from localStorage each time they're used
// These work in template literals because they implement toString()
export const API_BASE_URL = new DynamicApiUrl(getApiBaseUrl);
export const SOCKET_URL = new DynamicApiUrl(getSocketUrl);
export const QR_BASE_URL = new DynamicApiUrl(getQrBaseUrl);

// For documentation examples, always use production URL
export const DOCS_API_BASE_URL = PRODUCTION_API_BASE_URL;

// Export individual URLs for environment switching
export { DEVELOPMENT_API_BASE_URL, PRODUCTION_API_BASE_URL };

// For backward compatibility and easy switching
export const API_CONFIG = {
  get baseURL() {
    return getApiBaseUrl();
  },
  get socketURL() {
    return getSocketUrl();
  },
  get qrBaseURL() {
    return getQrBaseUrl();
  },
  docsBaseURL: DOCS_API_BASE_URL,
  get isDevelopment() {
    return !isProductionMode();
  },
};

export default API_CONFIG;
